import { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';

import { WithConfig } from 'containers/WithConfig';
import { MainStoreState } from 'modules/main/store/MainStoreState';

import { SsrConfig } from './types/SsrConfig';

type Props = {
  store: Store<MainStoreState>;
  config: SsrConfig;
  children?: ReactNode;
};

export function SsrWrapper({ store, config, children }: Props) {
  return (
    <Provider store={store}>
      <WithConfig config={config}>{children}</WithConfig>
    </Provider>
  );
}
